// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_39a97","share-button":"_88Dko","qr":"_3ZHrK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareModal/QRCodeShareButton.scss
// module id = ./src/components/ShareModal/QRCodeShareButton.scss
// module chunks = 4